module.exports = __webpack_public_path__ + "img/Andrea McLeod-Karim.514c209.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/testimonial/Andrea McLeod-Karim.jpg
// module id = 1069
// module chunks = 1